const TEN_MINS = 10 * 60 * 1000;

export const isExpired10mins = (time: number) => {
    const diff = new Date().getTime() - time;

    return diff > TEN_MINS;
};
